import { defineRouting } from "next-intl/routing";
export const routing = defineRouting({
  locales: ["en", "zh-Hans"], defaultLocale: "en",
  localePrefix: {mode: "as-needed", prefixes: {"zh-Hans": "/zh"}},
  localeDetection: false, localeCookie: false, alternateLinks: false,
});
